import { getRootDomain } from '../utils/stringUtil';

const FantasyLogo = 'theme/Fantasy/title.png';
const FantasyIcon = 'theme/Fantasy/favicon.png';
const FantasyLoader = 'theme/Fantasy/Loader.gif';


const boomx2Logo = 'theme/boomx2/title.png';
const boomx2Icon = 'theme/boomx2/favicon.png';
const boomx2Loader = 'theme/boomx2/Loader.gif';
const boomx4Logo = 'theme/boomx4/title.png';
const boomx4Icon = 'theme/boomx4/favicon.png';
const boomx4Loader = 'theme/boomx4/Loader.gif';
export interface WhitelabelEnvDTO {
  FOLDER_NAME: string;
  BRAND_NAME: string;
  BRAND_DOMAIN: string;
  logo: any;
  favicon: any;
  Loader: any;
  telegramBot?: string;
  skins?: Array<{
    label: string;
    domain: string;
    disabled?: boolean;
  }>;
}

const fantasyEnvs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'Fantasy',
  BRAND_NAME: 'FantasyHub',
  BRAND_DOMAIN: 'fantasyhub.vip',
  logo: FantasyLogo,
  favicon: FantasyIcon,
  Loader: FantasyLoader,
  telegramBot: 'https://t.me/fantasy11hub_bot',
};


const boomx2Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'boomx2',
  BRAND_NAME: 'boomx2',
  BRAND_DOMAIN: 'boomx2.st247id.site',
  logo: boomx2Logo,
  favicon: boomx2Icon,
  Loader: boomx2Loader,
};


const boomx4Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'boomx4',
  BRAND_NAME: 'boomx4',
  BRAND_DOMAIN: 'boomx4.mpid.site',
  logo: boomx4Logo,
  favicon: boomx4Icon,
  Loader: boomx4Loader,
};

export const WhitelabelEnvMap = {
  'boomx4.mpid.site': boomx4Envs,
  'boomx2.st247id.site': boomx2Envs,
  localhost: fantasyEnvs,

  // Stage domains
  'fantasyhub.vip': fantasyEnvs,

};

const normalizePublicAssetPath = (assetPath: any) => {
  if (typeof assetPath !== "string") return assetPath;
  if (!assetPath) return assetPath;
  if (assetPath.startsWith("/") || assetPath.startsWith("http") || assetPath.startsWith("data:")) {
    return assetPath;
  }
  return `/${assetPath}`;
};

export function getEnvVariable(domain: string, variable: keyof WhitelabelEnvDTO): any {
  const cleanDomain = domain.replace(/www./g, '');
  const env = WhitelabelEnvMap[cleanDomain as keyof typeof WhitelabelEnvMap];

  if (!env) {
    throw new Error(`Domain '${cleanDomain}' not found in WhitelabelEnvMap`);
  }

  const value = env[variable];
  if (variable === "logo" || variable === "favicon") {
    return normalizePublicAssetPath(value);
  }
  return value;
}

let cachedLoader: string | null = null;
let isLoaderInitialized = false;

export const getLoader = (domain: string): string => {
  if (isLoaderInitialized && cachedLoader !== null) {
    return cachedLoader;
  }

  const loader = getEnvVariable(domain, 'Loader');
  cachedLoader = typeof loader === 'string' ? loader : String(loader);
  isLoaderInitialized = true;

  return cachedLoader;
};

export const Loader = (domain: string) => getLoader(domain);

export const getTelegramBotLink = (domain: string): string => {
  const cleanDomain = domain.replace(/www./g, '');
  const env = WhitelabelEnvMap[cleanDomain as keyof typeof WhitelabelEnvMap];

  if (!env || !env.telegramBot) {
    // Fallback to default Strike46 bot if no specific bot is configured
    return 'https://t.me/fantasy11hub_bot';
  }

  return env.telegramBot;
};